// Config for the Stage Transition Rules admin screen — mirrors the shape of
// config/roles_and_permissions.js (column defs consumed by DynamicTable).

export const TRANSITION_ACTION_TYPES = [
    "CHANGE_STATE",
    "INVALIDATE_DATA",
    "MAKE_EDITABLE",
    "ENFORCE_GATE",
    "REVERSE_TRIGGER",
    "REGENERATE_DOCUMENT",
    "SEND_NOTIFICATION",
    "ENFORCE_TWO_PERSON_RULE",
    "REQUIRE_REASON",
    "LOG_TRANSITION",
];

// LOG_TRANSITION is auto-appended by the backend on every save — the builder
// never lets an author add/remove/reorder it manually.
export const AUTHORABLE_ACTION_TYPES = TRANSITION_ACTION_TYPES.filter(
    (type) => type !== "LOG_TRANSITION"
);

export const STAGE_TRANSITION_RULES_DATA = [
    {
        key: "label",
        label: "Rule",
        type: "text",
        render: (row) => row?.label || `${row?.from_stage_name || "?"} → ${row?.to_stage_name || "?"}`,
    },
    {
        key: "direction",
        label: "Direction",
        type: "badge",
    },
    {
        key: "scope",
        label: "Scope",
        type: "badge",
    },
    {
        key: "action_count",
        label: "Actions",
        type: "text",
        render: (row) => row?.actions?.length ?? 0,
    },
    {
        key: "requires_two_person_rule",
        label: "Two-Person Rule",
        type: "status",
    },
    {
        key: "is_active",
        label: "Status",
        type: "status",
    },
    {
        key: "actions_menu",
        label: "",
        type: "actions",
        actions: [
            { key: "edit", label: "Edit Rule" },
            { key: "toggle-active", label: "Activate / Deactivate" },
            { key: "test", label: "Test Transition..." },
        ],
    },
];

export const INITIAL_RULE_FORM_STATE = {
    stage_transition_id: null,
    label: "",
    from_stage_id: "",
    to_stage_id: "",
    direction: "BACKWARD",
    scope: "APPLICATION",
    allowed_role_ids: [],
    requires_two_person_rule: false,
    requires_reason: false,
    reason_categories: [],
    actions: [],
};
